
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import PandaMobileTable from "@/components/mobile-custom/panda-table.vue";

import PandaMobileTWFContainer from "@/components/mobile-custom/panda-table-with-filter-container.vue";

import { AxiosData } from "@/common/http/http";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
import { SettingCompetitionAssistantAPI } from "@/common/api/competitionManage/settingCompetitionAssistant";

import { CommonApi } from "@/common/api/common";

// import ZlSelect from "@/components/third-custom-components/select";

// import ZlOption from "@/components/third-custom-components/option";

import { excuteDownloadExport2Excel } from "@/common/xlsx";
export const pageApiList = getPageAPIs(SettingCompetitionAssistantAPI);

import { shareConfirmOptions, leagueType2Text } from "@/common/config";

const defaultForm = {
  league_name: "", // 赛事名称
  shop_name: "", // 店铺名称

  time: [], // 时间
};

const defaultForms = {
  image_path: "", //
  image_id: "", //
};

const uploadPicMode2Titles: any = {
  league_schedule: "竞赛日程",
  league_cluster_qrcode: "群二维码",
  league_boardcast_bg: "报名页面",
};

const uploadPicMode2Field: any = {
  league_schedule: "league_schedule_image_id",
  league_cluster_qrcode: "wechat_cluster_qrcode",
  league_boardcast_bg: "league_register_image_id",
};
// const defaultSearchVenuePageOption = {
//   page: 1,
//   limit: 10,
//   isRearchBottom: false,
// };

// const transfromGenders: any = [
//   '',
//   '女',
//   '男'
// ]

@Component({
  filters: {
    // showUserMemberTypeName: function(type: number) {
    //   return transferUserLevel2ch[type] || ''
    // }
    showLeagueTypeName: function (type: number) {
      return leagueType2Text[type];
    },

    showCompetitionPkSetTYpeName(type: number) {
      // 类型:1单败 2双败
      const pkSetStatus2Text: string[] = ["", "单败", "双败"];

      return pkSetStatus2Text[type];
    },
  },
  components: {
    // ZlSelect,
    // ZlOption,
    PandaMobileTable,
    PandaMobileTWFContainer,
  },
})
export default class SettingCompetitionAssistant extends Vue {
  /** 移动端相关属性 方法 */
  private allMobileChooseFields: any[] = [
    {
      label: "比赛名称",
      field: "league_name",
    },
    {
      label: "店铺名称",
      field: "shop_name",
    },
    {
      label: "开赛时间",
      field: "league_start_time",
    },
    {
      label: "总奖金",
      field: "reward_price",
    },
    {
      label: "类型",
      field: "table-league-type",
    },
    {
      label: "报名人限制",
      field: "table-register-person-num-limit",
    },
    {
      label: "是否有预选赛",
      field: "table-qualifier",
    },
    {
      label: "操作时间",
      field: "opt_time",
    },
    {
      label: "操作人",
      field: "opt_name",
    },
    {
      label: "操作人",
      field: "table-option",
    },
  ];
  /** end 移动端相关属性 方法 */

  private settingCompetitionAssistantApi: any;

  private deepLoopUtil: any;

  private commonApi: any;

  // private utilIns: any;

  // private debounceRefreshSingleCardInfoFunc: any

  constructor() {
    super();
    this.settingCompetitionAssistantApi = new SettingCompetitionAssistantAPI();

    this.deepLoopUtil = new DeepLoop();
    this.commonApi = new CommonApi();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };

    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms),
    };

    // this.utilIns = new Util()

    // this.debounceRefreshSingleCardInfoFunc = this.utilIns.debounce.call(
    //   this,
    //   this.refreshSingleCardAccountInfo,
    //   800
    // )
  }

  private form: any;

  private forms: any;

  private firstLoading: boolean = true;
  // private chooseTechnicianItem : any = null;

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private activated(): void {
    this.getTable();
  }

  private getTable(): void {
    this.settingCompetitionAssistantApi.getCompetitionList(
      this.getCompetitionListParams(),
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      },
      false
    );
  }

  private getCompetitionListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const {
      league_name,
      shop_name,
      time, // 消费时间
      // finish_time, // 完成时间
    } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {};
    // if (shop_name) {
    //   outerParams.shop_name = shop_name;
    // }

    if (league_name) {
      outerParams.league_name = league_name;
    }

    if (shop_name) {
      outerParams.shop_name = shop_name;
    }

    if (Array.isArray(time) && time.length === 2) {
      const [startDate, endDate] = time;

      const startTime = Util.dateTimeUtilnohms(startDate);
      const endTime = Util.dateTimeUtilnohms(endDate);

      outerParams.start_date = startTime;

      outerParams.end_date = endTime;
    }

    if (
      mode == "exportExcel" &&
      !(outerParams.start_date && outerParams.end_date)
    ) {
      this.$message.error("请选择日期导出数据");
      return null;
    }

    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;

      outerParams.__isUnique = !firstLoading;
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  // 跳转 比赛设置页面 新增模式
  private handleGoAddCompetitionAssistant() {
    this.$router.push({
      path: "/addOrEditComplexCompetition",
      query: {
        mode: "add",
      },
    });
  }

  // 跳转 比赛设置页面 编辑模式
  private handleGoEditCompetitionAssistant(competitionItem: any) {
    console.log(competitionItem, "competitionItem");

    // ctid
    this.$router.push({
      path: "/addOrEditComplexCompetition",
      query: {
        mode: "edit",
        ctid: competitionItem.id,
      },
    });
  }

  // 全部参赛选手
  private handleGoAllCompetitionPartner(competitionItem: any) {
    console.log(competitionItem, "competitionItem");

    this.$router.push({
      path: "/allCompetitionPartnerList",
      query: {
        ctid: competitionItem.id,
      },
    });
  }

  // 上传图片

  private uploadPicIdField: string = "";

  private uploaderPicTitle: string = "";

  private imagePicUploading: boolean = false;

  private dialogFormVisible: boolean = false;

  private curUpdateCompetitionItem: any = {};

  private upadteCompetitionInfoLoading: boolean = false;

  private handleWakeCompetitionPic(competitionItem: any, mode: string) {
    const {
      league_schedule_image_id,
      league_schedule_image_url,

      wechat_cluster_qrcode,
      wechat_cluster_qrcode_url,

      league_register_image_id,
      league_register_image_url,
    } = competitionItem || {};

    this.curUpdateCompetitionItem = competitionItem;
    this.uploadPicIdField = uploadPicMode2Field[mode];

    this.uploaderPicTitle = uploadPicMode2Titles[mode];

    const forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms),
    };

    switch (mode) {
      case "league_schedule":
        Object.assign(forms, {
          image_path: league_schedule_image_url || "",
          image_id: league_schedule_image_id || "",
        });
        break;
      case "league_cluster_qrcode":
        Object.assign(forms, {
          image_path: wechat_cluster_qrcode_url || "",
          image_id: wechat_cluster_qrcode || "",
        });
        break;
      case "league_boardcast_bg":
        Object.assign(forms, {
          image_path: league_register_image_url || "",
          image_id: league_register_image_id || "",
        });
        break;
    }

    this.forms = forms;

    this.dialogFormVisible = true;
  }

  private handleUploadLeagueImagePic(file: any, fileList: any[]) {
    console.log(file, fileList, "file", "fileList");

    this.imagePicUploading = true;
    this.commonApi.getOss(
      file instanceof File ? file : file.raw,
      (res: any) => {
        console.log(res, "res 图片上传成功");

        const { data } = res;

        const { data: callbackData } = data;

        const { item: uploadImgObj } = callbackData || {};

        const { id, url } = uploadImgObj;

        this.$set(this.forms, "image_id", id);
        this.$set(this.forms, "image_path", url);

        this.imagePicUploading = false;
      },
      () => {
        this.$message.error("图片上传失败");

        this.imagePicUploading = false;
      }
    );
  }

  private handleUpadteCompetitionOtherInfo() {
    const forms = this.forms;

    const curUpdateCompetitionItem = this.curUpdateCompetitionItem;

    const uploadPicIdField = this.uploadPicIdField;

    const {
      // image_path,
      image_id,
    } = forms || {};

    if (!image_id) {
      this.$message.error("请上传图片");
      return;
    }

    const params = {
      league_id: curUpdateCompetitionItem.id,
      [uploadPicIdField]: image_id || "",
    };

    this.upadteCompetitionInfoLoading = true;

    this.settingCompetitionAssistantApi.updateCompetitionOtherInfo(
      params,
      (res: any) => {
        this.upadteCompetitionInfoLoading = false;
        this.$message.success("图片信息已更新");

        this.getTable();

        this.dialogFormVisible = false;
      },
      () => {
        this.upadteCompetitionInfoLoading = false;
      }
    );
  }

  // private curSingleCardInfo: any = {}

  // private singleCardInfoLoading: boolean = false

  // // 获取单店会员余额
  // private refreshSingleCardAccountInfo() {
  //   const forms = this.forms

  //   const {
  //     phone,
  //     venue
  //   } = forms || {}

  //   if (phone && venue && venue.id) {
  //     this.singleCardInfoLoading = true

  //     this.settingCompetitionAssistantApi.getSingleCardAccountInfo({
  //       shop_id: venue.id,
  //       phone
  //     }, (res: any) => {
  //       const {
  //         shop_money
  //       } = res.data || {}

  //       this.singleCardInfoLoading = false

  //       this.$set(this.curSingleCardInfo, 'shop_money', shop_money || '')
  //       this.$set(this.curSingleCardInfo, 'errMsg', '')
  //     }, (err: any) => {

  //       console.log(err, 'err')

  //       this.singleCardInfoLoading = false

  //       const {
  //         message
  //       } = err || {}

  //       if (message) {
  //         this.$set(this.curSingleCardInfo, 'shop_money', '')
  //         this.$set(this.curSingleCardInfo, 'errMsg', message)
  //       }
  //     })
  //   }
  // }

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    // const { gender } = data;
    const newData = {
      ...data,
      // device_name: orderDeviceType2ch[device],
      // pay_type_name: payType2ch[pay_type],
      // user_level_type_name: userLevel2ch[user_type],
      // gender_sex: transfromGenders[gender]
    };

    return newData;
  }

  /** 对局设置 */
  private dialogPkSetVisible: boolean = false;

  private pkSetTableList: any[] = [];

  private curPkSetCompetitionItem: any = {};

  private handleWakePkSetDialog(competitionItem: any) {
    this.curPkSetCompetitionItem = competitionItem;

    const params = {
      league_id: competitionItem.id,
    };

    this.settingCompetitionAssistantApi.getCompetitionPkSetList(
      params,
      (res: any) => {
        const { list } = res.data || {};

        this.pkSetTableList = list.map(this.handlePkSetItem);

        this.dialogPkSetVisible = true;
      }
    );
  }

  private handlePkSetItem(pkSetItem: any) {
    const {
      // level,
    } = pkSetItem || {};

    const newPkSetItem = {
      ...pkSetItem,
    };

    return newPkSetItem;
  }

  // 跳转 单个比赛对局列表
  private handleGoPkSetListPreCompetition(pkSetItem: any) {
    const curPkSetCompetitionItem = this.curPkSetCompetitionItem;

    const { id: league_id, shop_id } = curPkSetCompetitionItem || {};

    const { is_mode, level, level_name, id } = pkSetItem || {};

    // 比赛模式  1正式比赛   2预选赛
    const allCommonIds = ["", level, id];

    const idOrLevel = allCommonIds[is_mode];

    this.dialogPkSetVisible = false;

    this.$router.push({
      path: "/competitionPkSetList",
      query: {
        mode: is_mode,
        ctid: league_id,
        spid: shop_id,
        name: level_name,

        idOrLevel,
      },
    });
  }

  // 跳转 单个比赛参赛选手列表
  private handleGoPkSetPartnerListPreCompetition(pkSetItem: any) {
    const curPkSetCompetitionItem = this.curPkSetCompetitionItem;

    const { id: league_id, shop_id } = curPkSetCompetitionItem || {};

    const { is_mode, level, id } = pkSetItem || {};

    // 比赛模式  1正式比赛   2预选赛
    const allCommonIds = ["", level, id];

    const idOrLevel = allCommonIds[is_mode];

    this.dialogPkSetVisible = false;

    this.$router.push({
      path: "/competitionPartnerPrePkSetList",
      query: {
        mode: is_mode,
        ctid: league_id,
        spid: shop_id,

        idOrLevel,
      },
    });
  }

  /** end 对局设置 */

  /** 远程搜索店铺 */
  // private venueList: any[] = [
  //   // {
  //   //   id: 1,
  //   //   label: '测试'
  //   // },
  //   // {
  //   //   id: 2,
  //   //   label: '测试2'
  //   // }
  // ];

  // private searchVenueLoading: boolean = false;

  // private remoteGetVenueQueryString: string = "";

  // private remoteSearchVenueTimer: any = null;

  // private searchVenuePageOption: any = {};

  // private initRemoteGetVenuePageOption() {
  //   this.searchVenuePageOption = {
  //     ...this.deepLoopUtil.deepCopy(defaultSearchVenuePageOption, false),
  //   };
  // }

  // private getSearchVenueParams() {
  //   const searchVenuePageOption = this.searchVenuePageOption;

  //   const remoteGetVenueQueryString = this.remoteGetVenueQueryString;

  //   const { page, limit } = searchVenuePageOption;

  //   const params: any = {
  //     page,
  //     limit,
  //   };

  //   if (remoteGetVenueQueryString && remoteGetVenueQueryString.trim()) {
  //     params.name = remoteGetVenueQueryString.trim();
  //   }

  //   return params;
  // }

  // private getMoreVenueList(refresh: boolean = true) {
  //   return new Promise((resolve: Function, reject: Function) => {
  //     if (refresh) {
  //       this.initRemoteGetVenuePageOption();
  //     }

  //     const params = this.getSearchVenueParams();

  //     this.settingCompetitionAssistantApi.searchVenueList(
  //       params,
  //       (res: any) => {
  //         console.log(res, "res");

  //         const venueList: any[] = res.data || [];

  //         this.venueList = refresh
  //           ? venueList
  //           : this.venueList.concat(venueList);

  //         if (Array.isArray(res.data) && res.data.length == 0) {
  //           this.searchVenuePageOption.isRearchBottom = true;
  //         }
  //         this.searchVenueLoading = false;

  //         this.addVenueListLoading = false;

  //         resolve();
  //       },
  //       () => {
  //         this.searchVenueLoading = false;

  //         this.addVenueListLoading = false;

  //         reject();
  //       }
  //     );
  //   });
  // }

  // // 第一次搜索 无关键字
  // private handleFirstGetVenueList() {
  //   this.searchVenueLoading = true;

  //   this.getMoreVenueList(true);
  // }

  // // 清空搜索
  // private handleClearGetVenueList() {
  //   this.remoteGetVenueQueryString = "";

  //   this.searchVenueLoading = true;

  //   this.getMoreVenueList(true);
  // }

  // // 远程搜索
  // private remoteGetVenueMethod(query: string) {
  //   query = query.trim ? query.trim() : "";

  //   if (query !== "") {
  //     this.remoteGetVenueQueryString = query;
  //     clearTimeout(this.remoteSearchVenueTimer);

  //     this.remoteSearchVenueTimer = setTimeout(() => {
  //       this.searchVenueLoading = true;

  //       this.getMoreVenueList();
  //       // searchStu((res) => {
  //       //   const {
  //       //     students,
  //       //     total_count
  //       //   } = res || {}

  //       //   this.remoteAllStudents = [
  //       //     ...(students || [])
  //       //   ]

  //       //   this.remoteStudentTotalCount = total_count || 0

  //       //   this.remoteGetStudentLoading = false
  //       // }, {
  //       //   kw: query,
  //       //   ...this.getRemoteGetStudentPageOptionParams()
  //       // }, () => {
  //       //   this.remoteGetStudentLoading = false
  //       // })
  //     }, 300);
  //     // setTimeout(() => {
  //     //   this.remoteGetStudentLoading = false;
  //     //   this.options = this.list
  //     // }, 200);
  //   } else {
  //     this.remoteGetVenueQueryString = "";
  //     this.venueList = [];
  //   }
  // }

  // private addVenueListLoading: boolean = false;

  // private remoteAddVenueMethod() {
  //   if (this.addVenueListLoading) return;
  //   const searchVenuePageOption = this.searchVenuePageOption;

  //   const { isRearchBottom } = searchVenuePageOption;

  //   if (isRearchBottom) return;

  //   this.searchVenuePageOption.page++;

  //   this.addVenueListLoading = true;

  //   this.getMoreVenueList(false);
  // }
  /** end 远程搜索店铺 */

  /** 导出excel */
  // private downloadExcelLoading: boolean = false;

  // // 订单字段名 文案对应关系
  // private orderExcelList2ch: any = {
  //   "phone": "手机号",
  //   "user_name": "用户昵称",
  //   "reason": "原因",
  //   "opt_name": "操作人",
  //   "opt_time": "操作时间"
  // };
  // // 订单Excel 表头的先后顺序
  // private orderExcelSortList: string[] = [
  //   "phone",
  //   "user_name",
  //   "reason",
  //   "opt_name",
  //   "opt_time"
  // ];

  // // 点击导出excel 表格
  // private handleDownloadExcel() {
  //   const params = this.getCompetitionListParams("exportExcel");

  //   if (params === null) {
  //     return false;
  //   }

  //   this.downloadExcelLoading = true;
  //   this.settingCompetitionAssistantApi.exportExcelSSaleMachineBlackUserList(
  //     params,
  //     (res: any) => {
  //       const {
  //         start_date,
  //         end_date,
  //         // over_start_time,
  //         // over_end_time,
  //       } = params || {};

  //       const create_time_duration_name =
  //         start_date && end_date
  //           ? `时间${start_date}到${end_date}`
  //           : "";

  //       // const finish_time_duration_name =
  //       //   over_start_time && over_end_time
  //       //     ? `完成时间${over_start_time}到${over_end_time}`
  //       //     : "";
  //       const filename = `售卖柜黑名单列表 ${create_time_duration_name}.xlsx`;
  //       const { data } = res || {};

  //       const { list: originList } = data || {};

  //       const newList = Array.isArray(originList)
  //         ? originList.map((item) => {
  //             const {
  //               // type,

  //             } = item || {};

  //             const newItem = {
  //               ...(item || {}),

  //               // memberTypeName: transferUserLevel2ch[type]
  //             };

  //             return newItem;
  //           })
  //         : [];

  //       if (newList.length > 0) {
  //         const orderExcelSortList = this.orderExcelSortList;

  //         const orderExcelList2ch = this.orderExcelList2ch;

  //         const excelJSONData = getExcelJSONDataByList(
  //           newList,
  //           orderExcelSortList,
  //           orderExcelList2ch
  //         );

  //         excuteDownloadExport2Excel(excelJSONData, filename);
  //       } else {
  //         this.$message.info("选中时段没有可导出的信息");
  //       }

  //       this.downloadExcelLoading = false;
  //     },
  //     () => {
  //       this.downloadExcelLoading = false;
  //     }
  //   );
  // }

  /** end 导出excel */

  private restForm(): void {
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }
}
